<style src="../../assets/style.css"></style>
<template>
    <v-layout
            wrap
            class="mobile_menu"
    >
        <v-toolbar>
            <v-toolbar-side-icon class="mobile_menu_img" @click="returnToHome()">
<!--                <img src="./../../assets/sigla.png" >-->
                <img :src="menuLogo" >
            </v-toolbar-side-icon>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <div>
                    <v-btn
                            class="mobile_menu_activate"
                            @click.stop="drawer = !drawer"
                    >
                        <v-icon>menu</v-icon>
                    </v-btn>
<!--
                    <v-btn icon  @click="active = !active">
                        <v-icon>search</v-icon>
                    </v-btn>
-->
<!--
                    <span class="showInputCover">
                        <input type="text" id="searchInput" :class="{ showInput : active }">
                    </span>
-->

                </div>
            </v-toolbar-items>

        </v-toolbar>
        <v-navigation-drawer
                v-model="drawer"
                temporary
                fixed
                right
        >
            <v-list class="pa-1" >
                <v-list-tile avatar>
                    <v-list-tile-avatar style="margin: 0 auto;"  @click="returnToHome()">
                        <img :src="menuLogo" >
                    </v-list-tile-avatar>

                </v-list-tile>
            </v-list>

            <v-list class="pt-0" dense v-for="nivel1Button in menuItems">

                <v-list-tile

                        v-if="nivel1Button.nivel2 === undefined"
                        @click=""
                >

                    <v-list-tile-content>
                        <v-list-tile-title v-if="nivel1Button.nivel2 === undefined" @click="goToPage(nivel1Button.link)">{{ nivel1Button.name }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-group
                        v-if="nivel1Button.nivel2 !== undefined"
                >
                    <template v-slot:activator>
                        <v-list-tile >
                            <v-list-tile-title>{{ nivel1Button.name }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <v-list-group
                            no-action
                            sub-group
                            v-for="nivel2Button in nivel1Button.nivel2"
                            v-if="nivel2Button.nivel3 !== undefined"
                    >
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-title >{{nivel2Button.name}}</v-list-tile-title>
                            </v-list-tile>
                        </template>

                        <v-list-tile
                                v-for="nivel3Button in nivel2Button.nivel3"
                                @click=""
                        >
                            <v-list-tile-title class="menu_mobile_single_nivel3" @click="goToPage(nivel3Button.link)" >{{nivel3Button.name}}</v-list-tile-title>
                        </v-list-tile>
                    </v-list-group>
                    <template v-else>
                        <v-list-tile >
                            <v-list-tile-title class="menu_mobile_single" @click="goToPage(nivel2Button.link)">{{ nivel2Button.name }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
        <app-loader v-if="loadIn === true"></app-loader>
    </v-layout>
</template>

<script>
import appLoader from "./Loader"
    export default {
        data () {
            return {
                loadIn: true,
                drawer: null,
                active: false,
                menuLogo:'',
                menuItems: [],
                pages: {},
                routes: []
            }
        },
        created () {
            this.getMenu()
            this.getPages()
        },
           components: {
            appLoader
        },
        watch: {
            $route (to, from) {
                this.getPages()
                this.loadIn = true
            }
        },
        methods: {
            returnToHome () {
                this.$router.push('/')
            },
            getMenu ()
            {
                this.$http.get('/menu/1')
                    .then(response => {
                        this.menuLogo = response.data[0].logo
                        this.menuItems = response.data[0].meniu.nivel1
                    })
                    .catch(e => {
                        console.log(e)
                        this.$router.push('/404')
                    })
            },
            goToPage (pageSlug)
            {
                if(pageSlug == '/home') {
                    this.$router.push(`/`)
                } else {
                    this.$router.push(`/${pageSlug}`)
                }
            },
            getPages () {
                this.$http.get(`/pagelist`)
                .then(response => {
                    this.pages = response.data
                    setTimeout(() => {
                        this.loadIn = false
                    }, 1000)
                })
                .then(() => {
                    this.createRoutes()
                })
                .catch(e => console.log(e))
            },
            createRoutes () {
                this.routes = []
                for(let i = 0; i < this.pages.length; i++) {
                    switch(this.pages[i].template) {
                        case 'about':
                            this.routes.push({
                                path: `/${this.pages[i].slug}`,
                                name: `${this.pages[i].slug}`,
                                component: () => import('./../DespreNoi.vue')
                            })
                            break;
                        case 'solutions':
                            this.routes.push({
                                path: `/${this.pages[i].slug}`,
                                name: `${this.pages[i].slug}`,
                                component: () => import('./../SolutiiTehnologice.vue')
                            })
                            break;
                        case 'contact':
                            this.routes.push({
                                path: `/${this.pages[i].slug}`,
                                name: `${this.pages[i].slug}`,
                                component: () => import('./../Contact.vue')
                            })
                            break;
                        case 'service':
                            this.routes.push({
                                path: `/${this.pages[i].slug}`,
                                name: `${this.pages[i].slug}`,
                                component: () => import('./../Service.vue')
                            })
                            break;
                        case 'consulting':
                            this.routes.push({
                                path: `/${this.pages[i].slug}`,
                                name: `${this.pages[i].slug}`,
                                component: () => import('./../Consultanta.vue')
                            })
                            break;
                        case 'gdpr':
                            this.routes.push({
                                path: `/${this.pages[i].slug}`,
                                name: `${this.pages[i].slug}`,
                                component: () => import('./../Gdpr/Gdpr.vue')
                            })
                            break;
                        case 404:
                            this.$router.push('/404')
                            break;
                        default:
                        // code block
                    }
                }
                this.routes.push({
                    path: '*',
                    name: '404',
                    component: () => import('./../404.vue')
                })
                this.$router.addRoutes(this.routes)
            }
        }
    }
</script>
